import { render, staticRenderFns } from "./multiple-select.vue?vue&type=template&id=46e21152&"
import script from "./multiple-select.vue?vue&type=script&lang=js&"
export * from "./multiple-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports